








/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../helpers";
// updateAuthUser
// UPDATEAUTHUSER
const UPDATEAUTHUSER= createAsyncThunk(
  "updateAuthUser/updateAuthUser",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const updateAuthUserSlice = createSlice({
  name: "updateAuthUserSlice",
  initialState: {
    updateAuthUser: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfupdateAuthUser: (state) => {
        state.updateAuthUser.loading = false
        state.updateAuthUser.error = false
        state.updateAuthUser.data = []
        state.updateAuthUser.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(UPDATEAUTHUSER.fulfilled, (state, action) => {
      state.updateAuthUser = {
        ...state.updateAuthUser,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(UPDATEAUTHUSER.pending, (state, action) => {
      state.updateAuthUser = {
        ...state.updateAuthUser,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(UPDATEAUTHUSER.rejected, (state, action) => {
      state.updateAuthUser = {
        ...state.updateAuthUser,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const updateAuthUserAction = {
    UPDATEAUTHUSER,
};

export { updateAuthUserAction };
export default updateAuthUserSlice.reducer;
export const {setInitialStateOfupdateAuthUser} = updateAuthUserSlice.actions
